<template>
    <div>
        <div class="NewMessage">
            
            <New></New>
        </div>

        <div class="Message">
            在此显示已经留言
        </div>
    </div>


</template>
<script>
import New from '../NewMessage/New.vue'
export default ({
    data() {
        return {

        }
    },
    components: {
        New
    }

})
</script>
<style>
.Message {
    border: 1px red solid;
}

.NewMessage {
    border: 2px yellow solid;
}
</style>


// WEBPACK FOOTER //
// src/components/NewMessage/NewMessage.vue